/* eslint-disable import/no-anonymous-default-export */
import { SET_FILTER, SET_ALL_FILTER } from './types';
import { get, set } from 'global/lib/lodash';

const removeUndefined = (obj) => {
  const newobj = {};
  for (let k in obj) {
    const val = obj[k];
    if (val !== undefined) {
      newobj[k] = val;
    }
  }
  return newobj;
};

export default function (filterType, filter, data) {
  return (dispatch, getState) => {
    const sState = getState();

    /* 
      Every screen has its own set of filters. But in some cases, when a user changes
      a filter on one screen, we want the filter in another screen to match it. So that 
      it SEEMS like these filters are the same across screens. This matchInFilter method
      is an attempt to accomplish that.
    */
    const matchInFilter = (category, filtersToMatch) => {
      filtersToMatch.forEach((f) => {
        const d = get(sState, `filter.${category}.${f}`, {});
        const _data = (() => {
          const allowedkeys = Object.keys(data).filter((k) => d.hasOwnProperty(k));
          const obj = { ...data };
          for (let key in obj) {
            if (allowedkeys.indexOf(key) === -1) {
              delete obj[key];
            }
          }
          return obj;
        })();
        set(
          sState,
          `filter.${category}.${f}`,
          removeUndefined({
            ...d,
            ..._data,
            _sort: data._sort || d._sort,
          })
        );
      });
      dispatch({ type: SET_ALL_FILTER, data: get(sState, 'filter') });
    };

    if (filterType === 'reports') {
      matchInFilter('reports', ['list', 'data', 'photo']);
    } else if (filterType === 'tasks') {
      matchInFilter('tasks', ['list', 'realm', 'scorecard']);
    } else if (filterType === 'library') {
      matchInFilter('library', ['editions', 'courses']);
    } else {
      dispatch({ type: SET_FILTER, filterType, filter, data });
    }
  };
}
